module.exports = __webpack_public_path__ + "media/female.c6c9ef76.mp3";